const cleanCourseMap = (data) => {
  Object.values(data.years).forEach((y) =>
    y.periods.forEach((p) => (p.blocks = p.blocks.filter((item) => item)))
  )

  return data
}

export default cleanCourseMap
